import { ModuleData } from "../models/module.model";
import { HttpClient } from "@angular/common/http";

import {

  Injectable,

  Compiler,

} from "@angular/core";
// import "rxjs/add/operator/map";

// Needed for the new modules


import {  Observable, BehaviorSubject, Subject } from "rxjs";
import {
  tap,

  map,

} from "rxjs/operators";


import { SiteService } from "../sites-management/site.service";



@Injectable()
export class ModuleService {
  formSaved = true;

  formData: any = {
    general: {},
    seo: {},
    template: {},
    relatedPost: {},
  };

  private formsSubject = new BehaviorSubject<any>({});
  isFormsChanged$: Observable<void> = this.formsSubject.asObservable();

  private formDataSubject = new Subject<void>();
  isFormDataChanged$: Observable<void> = this.formDataSubject.asObservable();

  private allPagesSubject = new BehaviorSubject<any[]>([]);
  allPages$: Observable<any[]> = this.allPagesSubject.asObservable();

  site: any;
  constructor(private compiler: Compiler, private http: HttpClient, private siteService: SiteService) {
    this.getAllPages();
    this.siteService.isSiteChanged$.subscribe((res) => {
      this.getAllPages();
    })
  }

  ComponentFactory: any[] = [];
  theme: any = {};

  /**
   * Namespace objects of the setting-lib bundles, keyed by their module path.
   * Kept so the host can reach exported tokens (e.g. ApiGroupCatalogService)
   * of a bundle that is only ever loaded through a dynamic import.
   */
  loadedModules: Record<string, any> = {};

  /** Looks up an export across every loaded bundle. */
  getBundleExport<T = any>(name: string): T | null {
    for (const path of Object.keys(this.loadedModules)) {
      const found = this.loadedModules[path]?.[name];
      if (found) return found as T;
    }
    return null;
  }

  loadModules(): Observable<ModuleData[]> {
    return this.http
      .get<ModuleData[]>(window.location.origin + `/assets/bundels/modules.json`)
      .pipe(map((res: any) => res));
  }

  public updateFormData(key, value) {
    Object.assign(this.formData, {
      [key]: value,
    });
    this.formsSubject.next(this.formData);
    this.formSaved = false;
  }

  setComponentFactories(ComponentFactory) {
    for (let index = 0; index < ComponentFactory.length; index++) {
      const element = ComponentFactory[index];
      this.ComponentFactory[element.name] = element;
    }
  }

  async loadModuleSystemJS(moduleInfo: ModuleData) {

let module:any
    switch (moduleInfo.path) {
      case '../../assets/bundels/common-setting-component-lib':
         module = await import('../../assets/bundels/common-setting-component-lib');
        break;
      case '../../assets/bundels/ecommerce-setting-component-lib':
         module = await import('../../assets/bundels/ecommerce-setting-component-lib');
        break;
        case '../../assets/bundels/intranet-setting-component-lib':
          module = await import('../../assets/bundels/intranet-setting-component-lib');
         break;
      default:
        throw new Error(`Unknown module path: ${moduleInfo.path}`);
    }

    this.loadedModules[moduleInfo.path] = module;

    return module[moduleInfo.moduleName].ɵmod.declarations;

  }

  getAllPages() {
    let pageParams = {
      "pageName": "",
      "status": 0,
      "pageCategory": 0,
      "cultureId": 0,
      "cultureCode": "",
      "pageNumber": 0,
      "pageSize": 20,
      "searchText": ""
    }
    return this.http.post("/Pages/GetAllPages", pageParams).pipe(
      map((x: any) => x &&  x.
      pages&& x.pages.map(x => x.pageCultureDetails)),

      map((x: any) => x && x.reduce((arr, item) => arr = arr.concat([...item]), [])),

      tap((res: any) => {
        this.allPagesSubject.next(res);
      })).subscribe();


  }


}
